import React from 'react';
import { movdTokens } from '../design-system/movdTokens.js';

const team = [
  { name: 'Olivia Chen', role: 'Founder & CEO', bio: 'With over 15 years in the Canadian moving industry, Olivia founded Movd to bring transparency, care, and innovation to every move.', image: '/assets/assets/img/team/ceo.jpg' },
  { name: 'David Singh', role: 'Operations Manager', bio: 'David ensures every move runs smoothly, from logistics to last-mile delivery. His attention to detail sets the standard for our crews.', image: '/assets/assets/img/team/ops-manager.jpg' },
  { name: 'Samantha Lee', role: 'Senior Move Coordinator', bio: 'Samantha is your go-to for planning, questions, and support. She guides customers through every step.', image: '/assets/assets/img/team/move-coordinator.jpg' },
  { name: 'Mike Brown', role: 'Lead Mover', bio: 'Mike leads our moving crews with professionalism and care. He\u2019s known for his friendly attitude and safe handling.', image: '/assets/assets/img/team/lead-mover.jpg' },
  { name: 'Priya Patel', role: 'Customer Support Specialist', bio: 'Priya is always ready to help, ensuring every customer feels heard and valued.', image: '/assets/assets/img/team/customer-support.jpg' },
];

export default function TeamComponent() {
  return (
    <main style={{ padding: 32 }}>
      <h1 style={{ margin: '0 0 8px', fontSize: 32, fontWeight: 900 }}>Meet the Movd team</h1>
      <p style={{ marginBottom: 32, fontSize: 16 }}>Professional, friendly, and dedicated to your move.</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 24 }}>
        {team.map(member => (
          <div key={member.name} style={{ padding: 24, borderRadius: 12, boxShadow: movdTokens.shadow.raised, background: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, textAlign: 'center' }}>
            <img src={member.image} alt={member.name} style={{ width: 72, height: 72, borderRadius: '50%', objectFit: 'cover', marginBottom: 8 }} />
            <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>{member.name}</h2>
            <p style={{ margin: 0, color: movdTokens.color.content.secondary, fontSize: 12 }}>{member.role}</p>
            <p style={{ margin: '8px 0 0', fontSize: 14 }}>{member.bio}</p>
          </div>
        ))}
      </div>
    </main>
  );
}
